import { render, staticRenderFns } from "./FTeamSharePreview.vue?vue&type=template&id=1775d543&"
import script from "./FTeamSharePreview.vue?vue&type=script&lang=js&"
export * from "./FTeamSharePreview.vue?vue&type=script&lang=js&"
import style0 from "./FTeamSharePreview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports